const setSecondChildrenTitle = (id = null, val = null) => {
  return {
    type: 'SET_SECONDCHILDRENTITLE',
    id,
    data: val,
  }
}

export default {
  setSecondChildrenTitle,
}